// Header scroll
const header = document.getElementById('SiteHeader');
window.addEventListener('scroll', () => {
  header.classList.toggle('scrolled', window.scrollY > 20);
}, { passive: true });

// Mobile nav
const btn = document.getElementById('HamburgerBtn');
const nav = document.getElementById('MobileNav');
btn.addEventListener('click', () => {
  const open = nav.style.display === 'none' || nav.style.display === '';
  nav.style.display = open ? 'block' : 'none';
  btn.setAttribute('aria-expanded', open);
});

// Smooth scroll
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const target = document.querySelector(a.getAttribute('href'));
    if (target) {
      e.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: 'smooth' });
      nav.style.display = 'none';
    }
  });
});

// Scroll reveal
const reveals = document.querySelectorAll('.reveal');
const io = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
}, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
reveals.forEach(el => io.observe(el));

// FAQ accordion
function toggleFaq(btn) {
  const item = btn.closest('.faq__item');
  const isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq__item.open').forEach(el => el.classList.remove('open'));
  if (!isOpen) item.classList.add('open');
}

// Dynamic counters — vary per session
(function() {
  const count = 1322;
  document.querySelectorAll('.hero__social-proof-text strong').forEach(el => {
    el.textContent = count + ' hundeejere';
  });
  const fill = document.querySelector('.batch-bar__fill');
  if (fill) {
    const pct = 58 + Math.floor(Math.random() * 10);
    const remaining = Math.round((100 - pct) * 2.5);
    const countEl = document.querySelector('.batch-bar__count');
    if (countEl) countEl.textContent = remaining + ' pladser';
    fill.style.width = '0%';
    const batchObs = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        setTimeout(() => fill.style.width = pct + '%', 200);
        batchObs.disconnect();
      }
    }, { threshold: 0.5 });
    if (fill.closest('.batch-bar')) batchObs.observe(fill.closest('.batch-bar'));
  }
})();

// Signup forms
function handleSignup(e) {
  e.preventDefault();
  document.getElementById('SignupSuccess').style.display = 'block';
  document.getElementById('EmailInput').value = '';
  updateCounter();
}
function handleHeroSignup(e) {
  e.preventDefault();
  document.getElementById('HeroSuccess').style.display = 'block';
  document.getElementById('HeroEmail').value = '';
  document.getElementById('HeroForm').querySelector('button').textContent = '✓ TILMELDT';
  updateCounter();
}
function updateCounter() {
  const els = document.querySelectorAll('.hero__social-proof-text strong');
  els.forEach(el => {
    const current = parseInt(el.textContent.replace(/\D/g,''));
    el.textContent = (current + 1) + ' hundeejere';
  });
}

// Show sticky CTA after scrolling past hero
const heroSection = document.getElementById('Hero');
const stickyCta = document.getElementById('StickyCta');
if (heroSection && stickyCta) {
  window.addEventListener('scroll', () => {
    const heroBottom = heroSection.getBoundingClientRect().bottom;
    stickyCta.style.display = heroBottom < 0 ? 'flex' : 'none';
  }, { passive: true });
}
